import { DataTableCol } from "../../../components/tables/types";

export const RegisterDataGridCols: DataTableCol[] = [
  {
    title: "Select",
    control: "select", // special control for checkbox
    sortable: false,
    canShowColumn: true,
    isCheckbox: true, // custom property to mark as checkbox
  },
  {
    title: "Date",
    control: "createdAt",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Name",
    control: "name",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Phone Number",
    control: "contactNo",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Department",
    control: "department",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "College",
    control: "collegeName",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Degree Year",
    control: "degreeYear",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Assigned To",
    control: "bdiUserName",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Actions",
    control: "both",
    sortable: false,
    isEdit: false,
    isDelete: true,
    canShowColumn: true,
  },
];
